import { render, staticRenderFns } from "./IconSelectUp.vue?vue&type=template&id=27d47fd9"
import script from "./IconSelectUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconSelectUp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports